module.exports = __webpack_public_path__ + "img/108-35-floor.b0ecc473.jpg";